export const infoMessages = {
  overrideExistingApplication:
    'We see an application in progress, If you choose to retrieve a new one, it will override the existing one.',
};
